import AccommodationProjection from '@/types/projections/AccommodationProjection';

export const buildAccommodation = (url: URL): AccommodationProjection | undefined => {
  const communeId = url.searchParams.get('communeId');
  const id = url.searchParams.get('id');
  const identificationNr = url.searchParams.get('identificationNr');
  const name = url.searchParams.get('name');
  const addressStreetAndNumber = url.searchParams.get('addressStreetAndNumber');
  const addressZip = url.searchParams.get('addressZip');
  const addressCity = url.searchParams.get('addressCity');
  const active = url.searchParams.get('active') === 'true' || url.searchParams.get('active') === null;

  if (
    !communeId ||
    !id ||
    !identificationNr ||
    !name ||
    !addressStreetAndNumber ||
    !addressZip ||
    !addressCity ||
    !active
  ) {
    return;
  }

  return {
    id: parseInt(id, 10),
    identificationNr,
    name,
    addressStreetAndNumber,
    addressZip,
    addressCity,
    communeId: parseInt(communeId, 10),
    active,
  };
};

export default {
  buildAccommodation,
};
